module.exports = __webpack_public_path__ + "static/media/tamara.34130261.png";